/**
 * Browser Features
 */

// Modernizr Tests
import '@vendor/browsernizr/test/inputtypes';
import '@vendor/browsernizr/test/geolocation';
import '@vendor/browsernizr/test/touchevents';
import '@vendor/browsernizr/test/es6/promises';
import '@vendor/browsernizr/test/css/transitions';

// Dependencies
import Modernizr from '@vendor/browsernizr';

export const touchEvents = Modernizr.touchevents;
export const promises = Modernizr.promises;
export const cssTransitions = Modernizr.cssTransitions;
export const geolocation = Modernizr.geolocation;

export const inputtypesDates = Modernizr.inputtypes.date;
export const hasDatesButNoTouch = inputtypesDates && !touchEvents;

export const isWindowsDevice = navigator && navigator.appVersion && navigator.appVersion.indexOf('Win') >= 0;
export const isWindowsTouch = touchEvents && isWindowsDevice;

export const isIOS = navigator && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;



// WEBPACK FOOTER //
// ./project/client/src/core/services/browser-features.js